import { algoliaInsightsClient as insightsClient, isTrackingDisabled } from '../../algolia'
import { getCookie } from '@/helpers/cookies'
import { getQueryFromUrl } from '@/helpers/url'
import { getIndexNames } from '@/components/Search/config'

export const ALGOLIA = 'algolia'

/*
 * More information on Algolia insight events can be found here:
 * https://www.algolia.com/doc/api-client/methods/insights/
 */
export const ALGOLIA_EVENTS = {
  conversionAfterSearch: 'convertedObjectIDsAfterSearch',
}

export const ALGOLIA_EVENT_NAMES = {
  addToCart: 'Item added to cart',
}

export function trackAlgoliaEvent(event, payload) {
  if (!isTrackingDisabled) {
    insightsClient(event, payload)
  }
}

const algoliaEventHandlers = {}

Object.values(ALGOLIA_EVENTS).forEach(algoliaEvent => {
  const defaultHandler = (event, eventPayload) => {
    const { country, ...payload } = eventPayload

    trackAlgoliaEvent(event, {
      userToken: getCookie('on_uuid'),
      index: getIndexNames(country).products,
      ...payload,
    })
  }
  const handlers = {
    [ALGOLIA_EVENTS.conversionAfterSearch]: (event, eventPayload) => {
      const queryID = getQueryFromUrl('queryID')
      if (queryID && eventPayload.objectIDs) {
        defaultHandler(event, { queryID, ...eventPayload })
      }
    },
    default: defaultHandler,
  }
  algoliaEventHandlers[algoliaEvent] = handlers[algoliaEvent] || handlers.default
})
export default algoliaEventHandlers
